import { useTranslation } from 'react-i18next'
import React from 'react'

import InlineField from '../../../../../../../../../../components/Form/InlineField'
import Field from '../../../../../../../../../../components/Form/Field'

import { MAX_IMPRESSIONS, TIME_UNIT, TIME_UNIT_COUNT, timeUnitOptions, timeUnits } from '../fields'

import useStyles from './styles'

const FrequencyFields = ({ formik }) => {
  const { t } = useTranslation()
  const classes = useStyles()

  const isLifetime = formik.values[TIME_UNIT] === timeUnits.LIFETIME

  return (
    <div className={classes.frequencyFieldsWrapper}>
      {t('Limit to')}
      <InlineField className={classes.frequencyField} formik={formik} name={MAX_IMPRESSIONS} type="number" />
      {t('impressions per')}
      {!isLifetime && (
        <InlineField placeholder="" className={classes.timeUnitsCount} formik={formik} name={TIME_UNIT_COUNT} />
      )}
      <Field
        placeholder=""
        className={classes.timeUnitsSelect}
        formik={formik}
        name={TIME_UNIT}
        options={timeUnitOptions}
      />
    </div>
  )
}

export default FrequencyFields
